<template>
  <div>
    <list
      row-key="RecordId"
      ref="list"
      unit="商家信息"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        
        <el-form-item label="商家名称">
          <el-input v-model="params.BusiName" placeholder="请输入商家名称" clearable />
        </el-form-item>
        
        
        <el-form-item label="联系电话">
          <el-input v-model="params.ContactPhone" placeholder="请输入联系电话" clearable />
        </el-form-item>
        <el-form-item label="数据来源">
          <el-select v-model="params.DataSource" placeholder="请选择数据来源" clearable>
            <el-option :value="0" label="后台添加"></el-option>
            <el-option :value="1" label="小程序申请"></el-option>
            
          </el-select>
        </el-form-item>
      
        
      </template>
      <template slot="table">
        <!-- <el-table-column prop="OrderId" label="序号" width="60" align="center" /> -->
        <el-table-column prop="BusiCode" label="商家编号" /> 
        <el-table-column prop="BusiName" label="商家全称" />
        <el-table-column prop="BusiShortname" label="商家简称" />
        <el-table-column prop="RegTime" label="注册时间">
          <template slot-scope="{row}">
            {{row.RegTime}}
          </template>
        </el-table-column>
        <el-table-column prop="ContactName" label="联系人" />
        <el-table-column prop="ContactPhone" label="联系电话" />
        <el-table-column prop="Rate" label="平台分佣（%）" />
       
        <el-table-column prop="DataSource" align="center" label="数据来源" width="100">
          <template slot-scope="{row}">
              {{ row.DataSource==1?"小程序申请":"后台添加" }}     <!--内容不需要显示样式或图标的，只显示数据的，则直接用这句话即可-->
          </template>
        </el-table-column>      
                      
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/shop/business").default,
     
      params: {
      
        BusiName: "",
       
        ContactPhone: "",
     
        DataSource: null,
       
      
       CheckStates:[2]
      },
     
    };
  },
  beforeMount() {
   
  },
  mounted() {
    
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
